export default __webpack_public_path__ + "static/MartianMono-Regular-299f675959e68d47ddaa503213927d66.ttf";